import { useEffect, useState } from "react";
import Footer from "../../components/layouts/footer";
import { API_URL, URLS } from "../../_config";
import { useToken } from "../../_common/hooks/authHook";
import { proposalStatus, proposalStatusButton, replaceUrlParams, showDate } from "../../_common/functions";
import toast from "react-hot-toast";
import Nav from "../../components/layouts/nav";
import { Link, useNavigate } from "react-router-dom";
import Icon from "../../components/icon";
import Swal from 'sweetalert2';
import ProposalRejectModal from "../../components/modals/ProposalReject.modal";

const MyBusinessPlan = () => {
    const [myBusinessPlan, setMyBusinessPlan] = useState<any>(null);
    const navigate: any = useNavigate();
    const tokenData: any = useToken();
    const [isOpenRejectModal, setIsOpenRejectModal] = useState(false);
    const [actionRejectPlan, setActionRejectPlan] = useState({});

    const getMyBusinessPlan = async () => {
        try {
            const response = await fetch(API_URL.ACCOUNT.MY_BUSINESS_PLAN, {
                headers: { Authorization: `Bearer ${tokenData}` }
            });
            const resp = await response.json();
            setMyBusinessPlan(resp.data)
            if (resp.message == 'Unautheticated.') {
                navigate(URLS.LOGOUT);
            }
        } catch (error) {
            console.log('Error occurred while making the API request.', error);
            // Handle error
            setMyBusinessPlan([])
        }
    }

    const pdfDownload = (plan: any, type: string) => {
        return new Promise((resolve, reject) => {
            const APIURL = type === 'plan' ? API_URL.ACCOUNT.MY_BUSINESS_PLAN_DOWNLOAD : API_URL.ACCOUNT.MY_PROPOSAL_DOWNLOAD;
            fetch(APIURL + "/" + plan.id, {
                headers: { Authorization: `Bearer ${tokenData}` }
            }).then(response => response.json())
                .then(resp => {
                    if (resp?.status == 200) {
                        const pdfFile = type === 'plan' ? resp.data.plan_pdf : resp.data.proposal_pdf;
                        window.open(pdfFile, '_blank'); // Open URL in a new tab
                        resolve(resp.message);
                    } else {
                        reject(resp.message);
                    }
                }).catch(error => {
                    // Handle error
                    console.error('Error:', error);
                    reject(error.message);
                });
        })
    }
    const pdfFileDownloadHandler = async (plan: any, type: string) => { // type: "plan" or "proposal" | "invoice"
        toast.promise(
            pdfDownload(plan, type), {
            loading: 'Checking...',
            success: (msg: any) => {
                return <b>{msg}</b>
            },
            error: (msg: any) => { return <b>{msg}</b> },
        });
    }

    useEffect(() => {
        getMyBusinessPlan();
    }, [])
    useEffect(() => {
        if (isOpenRejectModal == false) {
            getMyBusinessPlan();

        }
    }, [isOpenRejectModal])



    const proposalApproval = (params: any) => {
        return new Promise((resolve, reject) => {
            fetch(API_URL.ACCOUNT.MY_BUSINESS_APPROVAL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenData}` },
                body: JSON.stringify(params),
            }).then(response => response.json()).then(resp => {
                if (resp?.status == 200) { // Success 
                    resolve(resp.message);
                    getMyBusinessPlan();
                } else {
                    reject(resp.message);
                }
            }).catch(error => {
                reject(error.message);
            });
        })
    }

    const proposalApprovalHandler = async (planData: any) => {
        Swal.fire({
            title: 'Approve Proposal',
            text: `Are you sure you want to approve this proposal?`,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#c4d72b',
            cancelButtonColor: '#c7694f',
            cancelButtonText: 'No, Reject it!',
            confirmButtonText: `Yes, Approve it!`,

        }).then((result: any) => {
            if (result.isConfirmed) {
                toast.promise(
                    proposalApproval({ proposal_id: planData.id }), {
                    loading: 'Checking...',
                    success: (msg: any) => {
                        navigate(replaceUrlParams(URLS.ACCOUNT.PAYMENT.PRICE_DETAILS, { proposalId: planData.id }))
                        return <b>{msg}</b>
                    },
                    error: (msg: any) => { return <b>{msg}</b> },
                });
            } else {
                // Swal.fire('Cancelled', 'Your action has been cancelled.', 'info');
                setIsOpenRejectModal(true);
                setActionRejectPlan(planData);
            }
        });

    }

    return (
        <>
            <Nav />
            <div className="body-part gray-bg mt-105">
                <div className="container text-center">
                    <h2 className="page-title">My <span>Business Service</span></h2>
                    <p className="tag-line">Manage your Business Service</p>

                    {
                        isOpenRejectModal &&
                        <ProposalRejectModal show={isOpenRejectModal} onClose={setIsOpenRejectModal} planData={actionRejectPlan} />
                    }

                    <div className="profile-box">
                        <div className="profile-box-title align-items-center">
                            <div className="d-flex align-items-center w-100">
                                <div className="profile-icon">
                                    <Icon name="business-card" />
                                </div>
                                <span>My Business Service</span>
                            </div>
                            <div className="align-items-center d-flex justify-content-between profile-text">

                                {
                                    myBusinessPlan && myBusinessPlan.length > 0 &&
                                    <Link to={URLS.SUBSCRIPTION} className=" ms-auto"><button type="button" className="master-orng-btn">New Plan</button></Link>
                                }

                            </div>
                        </div>
                        <div className="profile-box-data">
                            <div className="table-responsive">
                                <table className="table table-striped plan-craft-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Proposal Id</th>
                                            <th>Submitted Date</th>
                                            <th>Business Service</th>
                                            <th>Amount</th>
                                            <th>Proposal Status</th>
                                            <th style={{ minWidth: '200px' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {myBusinessPlan && myBusinessPlan.map((plan: any, index: number) => {
                                            const addonsIds = plan?.addons.map((addon: any) => addon.addon_id).join(',');
                                            return (
                                                <tr key={plan?.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{plan.proposal_no}</td>
                                                    <td>{showDate(plan.created_at)}</td>
                                                    <td>
                                                        <strong>{plan.subscription_plan?.title}</strong>
                                                    </td>
                                                    <td>
                                                        {plan?.plan_price == null ? 'QUOTE PRICE' : `${plan?.final_price_before_vat ? plan?.final_price_before_vat : plan?.plan_price} ${plan?.currency && plan.amount && plan?.currency.toUpperCase()}`}
                                                        {' +'} {plan.addonsPrice} {plan?.currency && plan.amount && plan?.currency.toUpperCase()}
                                                    </td>
                                                    {/* <td>
                                                        {plan?.plan_price == null ? 'QUOTE PRICE' : `${plan?.plan_price} ${plan?.currency && plan.amount && plan?.currency.toUpperCase()}`}
                                                        {' +'} {plan.addonsPrice} {plan?.currency && plan.amount && plan?.currency.toUpperCase()}
                                                    </td> */}
                                                    <td className={`status ${proposalStatusButton(plan.status)}`}><span>{proposalStatus(plan.status)}</span></td>
                                                    <td className="actions text-start">
                                                        <span title="View Questionnaire" data-bs-toggle="tooltip" data-bs-placement="top">
                                                            <Link to={replaceUrlParams(URLS.ACCOUNT.MY_BUSINESS_PLAN_DETAILS, { proposalId: plan.id })}><Icon name="eye" className="text-blue-500" /></Link></span>
                                                        {
                                                            plan?.answered_questionnaire_pdf?.original && <span title="View Answered" data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <Link to={plan?.answered_questionnaire_pdf?.original} target="_blank"><Icon name="file-signature" className="text-violet-400" /></Link></span>
                                                        }
                                                        {
                                                            plan.status >= 2 &&
                                                            <>
                                                                {
                                                                    plan?.proposal_pdf && plan?.proposal_pdf?.length > 0 && <span className="dropdown">
                                                                        <span className="dropdown-toggle proposal_pdf_download" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <Icon name="download-chat" className="text-gray-500" />
                                                                        </span>
                                                                        <ul className="dropdown-menu proposal_pdf_download_popup" aria-labelledby="dropdownMenuButton" style={{ border: '1px solid gray' }}>
                                                                            {
                                                                                plan?.proposal_pdf?.map((pdf: any, index: number) => {
                                                                                    return (
                                                                                        <li key={index}>
                                                                                            <Link to={pdf?.original} title={`Download Proposal ${index + 1}`} className="p-1 text-decoration-none" target="_blank" data-bs-toggle="tooltip" data-bs-placement="top">
                                                                                                Proposal File {index + 1}
                                                                                            </Link>
                                                                                        </li>
                                                                                    )
                                                                                })
                                                                            }
                                                                            {/* <li>
                                                                                <div title="Download Proposal" onClick={() => pdfFileDownloadHandler(plan, 'proposal')} data-bs-toggle="tooltip" data-bs-placement="top">
                                                                                    Download Proposal
                                                                                 </div>
                                                                            </li> */}
                                                                        </ul>
                                                                    </span>

                                                                }



                                                            </>

                                                        }
                                                        {
                                                            (plan.status == 0) &&
                                                            <span title="Edit Questionnaire"  >
                                                                <Link to={replaceUrlParams(URLS.BUSINESS_PLAN, { subscriptionId: plan.subscription_plan_id }) + "?addons=" + addonsIds + "&pId=" + plan.id}>
                                                                    <Icon name="edit" className="text-yellow-500 cursor-pointer" />
                                                                </Link>
                                                            </span>
                                                        }
                                                        {
                                                            (plan.status == 1) &&
                                                            <span title="Waiting for admin approval" data-bs-toggle="tooltip" data-bs-placement="top">
                                                                <Icon name="info" className="text-yellow-500" />
                                                            </span>
                                                        }
                                                        {/* {
                                                            plan.status == 3 && <span title="Amount not set yet for payment.">
                                                                <Icon name="money-off" className="text-red-500" />
                                                            </span>
                                                        } */}
                                                        {
                                                            (plan.status == 2) &&
                                                            <>
                                                                <span title="Waiting for your approval" data-bs-toggle="tooltip" data-bs-placement="top">
                                                                    <Icon name="approval" onClick={() => proposalApprovalHandler(plan)} />
                                                                </span>
                                                            </>
                                                        }
                                                        {
                                                            plan.status == 3 && plan?.payment_status != 1 && <>
                                                                {
                                                                    plan?.plan_price > 0 ?
                                                                        <span title="Please complete your payment." >
                                                                            {/* <Link to={replaceUrlParams(URLS.ACCOUNT.PAYMENT.PAY, { proposalId: plan.id })}>
                                                                                <Icon name="payment" className="text-green-500 cursor-pointer" />
                                                                            </Link> */}
                                                                            <Link to={replaceUrlParams(URLS.ACCOUNT.PAYMENT.PRICE_DETAILS, { proposalId: plan.id })}>
                                                                                <Icon name="payment" className="text-green-500 cursor-pointer" />
                                                                            </Link>
                                                                        </span>
                                                                        :
                                                                        <span title="Amount not set yet for payment." data-bs-toggle="tooltip" data-bs-placement="top">
                                                                            <Icon name="money-off" className="text-red-500" /></span>
                                                                }
                                                            </>
                                                        }
                                                        {
                                                            (plan?.payment_status == 1) && <>
                                                                <span title={`Paid on ${showDate(plan?.last_payment_at)}`} data-bs-toggle="tooltip" data-bs-placement="top"><Icon name="paid" /></span>

                                                                {plan?.invoice_pdf ? <Link to={plan?.invoice_pdf?.original} target="_blank" rel="noreferrer"
                                                                    // onClick={() => pdfFileDownloadHandler(plan, 'invoice')} 
                                                                    title={`${plan?.invoice_pdf ? "Download your invoice" : "Not ready to download invoice"}`} data-bs-toggle="tooltip" data-bs-placement="top">
                                                                    <Icon name="invoice" className="text-teal-600 cursor-pointer" />
                                                                </Link> : <span title="Not ready to download invoice." data-bs-toggle="tooltip" data-bs-placement="top"><Icon name="info" className="text-red-500" /></span>}
                                                            </>
                                                        }
                                                        {
                                                            (plan.status == 5 && plan?.payment_status == 1) &&
                                                            <>
                                                                {plan?.plan_pdf ? <span onClick={() => pdfFileDownloadHandler(plan, 'plan')} title={`${plan?.plan_pdf ? "Download Business Service" : "Not ready to download plan"}`} data-bs-toggle="tooltip" data-bs-placement="top">
                                                                    <Icon name="download-file-solid" className="text-green-500" />
                                                                </span> : <span title="Not ready to download plan." data-bs-toggle="tooltip" data-bs-placement="top"><Icon name="info" className="text-red-500" /></span>}
                                                            </>
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        <tr>
                                            {
                                                myBusinessPlan && myBusinessPlan.length === 0 && <td colSpan={7} className="text-center">
                                                    <p className="mt-3 text-red-500">No data found!</p>
                                                    <div className="btn-wrap mt-3">
                                                        <Link to={URLS.SUBSCRIPTION} ><button type="button" className="master-orng-btn">Start Your Business Service</button></Link>
                                                    </div>
                                                </td>
                                            }
                                            {
                                                !myBusinessPlan && <td colSpan={7} className="text-center"><p>Loading...</p></td>
                                            }

                                            {/* <Link to={URLS.PAYMENT.PAY}>Pay</Link> */}
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>

    )
}

export default MyBusinessPlan; 